import { render } from "./BalCheckbox.vue?vue&type=template&id=c58471e0&ts=true"
import script from "./BalCheckbox.vue?vue&type=script&lang=ts"
export * from "./BalCheckbox.vue?vue&type=script&lang=ts"

import "./BalCheckbox.vue?vue&type=style&index=0&id=c58471e0&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__